import { useState, useEffect } from "react";

/**
 * Hook to detect if code is running on the server (SSR) or client.
 *
 * This hook helps prevent React hydration mismatches when rendering
 * content that differs between server and client. It starts with
 * `isSSR = true` on both server and initial client render, then
 * updates to `false` after hydration via useEffect.
 *
 * @example
 * const isSSR = useSSR();
 *
 * return (
 *   <div>
 *     {!isSSR && <ClientOnlyComponent />}
 *   </div>
 * );
 *
 * @returns {boolean} isSSR - True during SSR and initial client render, false after hydration
 */
export const useSSR = () => {
  const [isSSR, setIsSSR] = useState(true);

  useEffect(() => {
    setIsSSR(false);
  }, []);

  return isSSR;
};

export default useSSR;
